<template>
    <div>
      <el-page-header @back="goBack"></el-page-header>
      <!-- 搜索筛选 -->
      <h3>小程序活跃</h3>
      <el-form :inline="true" :model="formInline" style="margin-top:15px" class="user-search">
        <el-form-item label="查询：">
          <el-date-picker
            v-model="formInline.yearmonth"
            format="yyyy 年 MM 月"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择月">
          </el-date-picker>
        </el-form-item>
        <el-form-item >
            <el-cascader
            :options="areaTreeList"
            :props="props"
            collapse-tags="true"
            v-model="formInline.area"
            clearable></el-cascader>
        </el-form-item>
        
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
        <div
            class="echart"
            ref="mychart"
            id="mychart"
            :style="{ float: 'left', width: '100%', height: '400px' }"
        ></div>

        <h3>麻将机活跃</h3>
      <el-form :inline="true" :model="formInline2" style="margin-top:15px" class="user-search">
        <el-form-item label="查询：">
          <el-date-picker
            v-model="formInline2.yearmonth"
            format="yyyy 年 MM 月"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择月">
          </el-date-picker>
        </el-form-item>
        <el-form-item >
            <el-cascader
            :options="areaTreeList"
            :props="props"
            collapse-tags="true"
            v-model="formInline2.area"
            clearable></el-cascader>
        </el-form-item>
        
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search2">查询</el-button>
        </el-form-item>
      </el-form>
        <div
            class="echart2"
            ref="mychart2"
            id="mychart2"
            :style="{ float: 'left', width: '100%', height: '400px' }"
        ></div>
    </div>
</template>
<script>
import * as echarts from "echarts";
import { censusCount , areaTree} from '../../api/userMG'
export default {
  data() {
    return {
        areaTreeList:[],
        props: { 
            multiple: false,
            emitPath:true,
            label:'name',
            value:'name',
            children:'areachildren'
        },
        formInline:{
            yearmonth:'',
            area:[]
        },
        formInline2:{
            yearmonth:'',
            area:[]
        },
        name: "张雪",
        xData: ["2020-02", "2020-03", "2020-04", "2020-05"], //横坐标数据
        yData: [30, 132, 80, 134] //纵坐标数据，与横坐标对应
    };
  },
  mounted() {
    this.areaTree()
    this.getTime();
  },
  methods: {
    areaTree(){
        areaTree().then(res=>{
            this.areaTreeList = res.data
        })
    },
    goBack(){
      window.history.back();
    },
    getTime(){
      let now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth()+1;
      this.formInline.yearmonth = `${year}-${month}`
      this.formInline2.yearmonth = `${year}-${month}`
      this.initEcharts()
      this.initEcharts2()
    },
    search(){
        this.initEcharts()
    },
    search2(){
        this.initEcharts2()
    },
    initEcharts() {
      const option = {
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        tooltip: {
          trigger: 'axis',
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: 'line',
            areaStyle: {
              color:"green",
              opacity: 0.3,
              origin:"start"
            }
          }
        ]
      };
      censusCount({
        type:2,
        yearmonth:this.formInline.yearmonth,
        province:this.formInline.area.length == 0?'':this.formInline.area[0],
        city:this.formInline.area.length == 0?'':this.formInline.area[1],
      }).then(res=>{
        option.xAxis.data = res.data.dates
        option.series[0].data = res.data.counts
        
        const myChart = echarts.init(this.$refs.mychart);// 图标初始化
        myChart.setOption(option);// 渲染页面
        //随着屏幕大小调节图表
        // window.addEventListener("resize", () => {
        //   myChart.resize();
        // });
      })
      
    },
    initEcharts2() {
      const option = {
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        tooltip: {
          trigger: 'axis',
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: 'line',
            areaStyle: {
              color:"green",
              opacity: 0.3,
              origin:"start"
            }
          }
        ]
      };
      censusCount({
        type:3,
        yearmonth:this.formInline.yearmonth,
        province:this.formInline.area.length == 0?'':this.formInline.area[0],
        city:this.formInline.area.length == 0?'':this.formInline.area[1],
      }).then(res=>{
        option.xAxis.data = res.data.dates
        option.series[0].data = res.data.counts
        
        const myChart = echarts.init(this.$refs.mychart2);// 图标初始化
        myChart.setOption(option);// 渲染页面
        //随着屏幕大小调节图表
        // window.addEventListener("resize", () => {
        //   myChart.resize();
        // });
      })
      
    }
  }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/echartsView/activeUsers.vue